// components/AnimatedButton.jsx
import React from "react";
import themeColors from "../themeColors";

export default function AnimatedButton({
  text,
  href,
  type = "link", // "link" | "submit" | "button"
  onClick,
}) {
  const classes =
    "relative inline-block px-6 py-3 rounded-xl font-semibold overflow-hidden group";
  const spanClasses =
    "absolute inset-0 overflow-hidden z-0";
  const fillClasses =
    "block w-0 h-[300%] -top-[110%] -left-[60%] absolute transform rotate-[15deg] transition-all duration-300 ease-out group-hover:w-[300%]";
  const textClasses = `relative z-10 transition-colors duration-300 text-[${themeColors.textDark}] group-hover:text-white`;

  const Fill = (
    <span className={spanClasses}>
      <span
        className={fillClasses}
        style={{
          background: `linear-gradient(to bottom right, ${themeColors.gradientFrom}, ${themeColors.gradientTo})`,
        }}
      />
    </span>
  );

  const Content = <span className={textClasses}>{text}</span>;

  if (type === "submit" || type === "button") {
    return (
      <button type={type} onClick={onClick} className={classes} style={{ backgroundColor: themeColors.buttonBg }}>
        {Fill}
        {Content}
      </button>
    );
  }

  return (
    <a href={href} className={classes} style={{ backgroundColor: themeColors.buttonBg }}>
      {Fill}
      {Content}
    </a>
  );
}
